//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { folderSpaceSubRuleApi, folderSubRuleApi } from '@/api/cloud';
export default {
  name: 'SpaceDialog',
  props: {
    fromData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      lookCheck: true,
      downloadCheck: false,
      editCheck: false,
      createCheck: false,
      deleteCheck: false,
      dialogData: [],
      userList: [],
      loading: false
    };
  },
  watch: {
    fromData: {
      handler: function handler(nVal) {
        this.getFolderShareRule();
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.userList = [];
      this.resetCheck();
      this.dialogVisible = false;
    },
    handleOpen: function handleOpen() {
      this.dialogVisible = true;
    },
    handleAdd: function handleAdd() {
      if (this.userList.length <= 0) {
        this.$message.error(this.$t('file.placeholder04'));
      } else {
        var list = [];
        var data = {};
        this.userList.forEach(function (value) {
          list.push({
            uid: value.card.uid,
            read: value.lookCheck ? 1 : 0,
            create: value.createCheck ? 1 : 0,
            download: value.downloadCheck ? 1 : 0,
            update: value.editCheck ? 1 : 0,
            delete: value.deleteCheck ? 1 : 0
          });
        });
        data = {
          rule: list
        };
        if (this.fromData.edit === 1) {
          this.getFolderShare(this.fromData.fid, this.fromData.id, data);
        }
      }
    },
    handleChange: function handleChange(type) {
      if (type === 1) {
        this.lookCheck ? this.checkAll('lookCheck') : this.checkNone('lookCheck');
      } else if (type === 2) {
        this.createCheck ? this.checkAll('createCheck') : this.checkNone('createCheck');
      } else if (type === 3) {
        this.editCheck ? this.checkAll('editCheck') : this.checkNone('editCheck');
      } else if (type === 4) {
        this.downloadCheck ? this.checkAll('downloadCheck') : this.checkNone('downloadCheck');
      } else {
        this.deleteCheck ? this.checkAll('deleteCheck') : this.checkNone('deleteCheck');
      }
    },
    // 全选
    checkAll: function checkAll(items) {
      this.userList.forEach(function (item) {
        item[items] = true;
      });
    },
    // 反选
    checkNone: function checkNone(items) {
      this.userList.forEach(function (item) {
        item[items] = false;
      });
    },
    resetCheck: function resetCheck() {
      this.lookCheck = false;
      this.downloadCheck = false;
      this.editCheck = false;
      this.createCheck = false;
      this.deleteCheck = false;
    },
    deleteShare: function deleteShare(index) {
      this.userList.splice(index, 1);
      if (this.userList.length <= 0) {
        this.resetCheck();
      }
    },
    // 添加
    getFolderShare: function getFolderShare(fid, id, data) {
      var _this = this;
      this.loading = true;
      folderSubRuleApi(fid, id, data).then(function (res) {
        _this.loading = false;
        _this.handleClose();
      }).catch(function (error) {
        _this.loading = false;
      });
    },
    // 权限列表
    getFolderShareRule: function getFolderShareRule() {
      var _this2 = this;
      folderSpaceSubRuleApi(this.fromData.fid, this.fromData.id).then(function (res) {
        _this2.userList = [];
        if (res.data.length > 0) {
          res.data.forEach(function (value) {
            var data = {
              card: value.user,
              id: value.to_uid
            };
            if (value.auth) {
              data.lookCheck = value.auth.read === 1;
              data.createCheck = value.auth.create === 1;
              data.downloadCheck = value.auth.download === 1;
              data.editCheck = value.auth.update === 1;
              data.deleteCheck = value.auth.delete === 1;
              _this2.lookCheck = value.auth.read === 1;
              _this2.createCheck = value.auth.read === 1;
              _this2.downloadCheck = value.auth.download === 1;
              _this2.editCheck = value.auth.update === 1;
              _this2.deleteCheck = value.auth.delete === 1;
            } else {
              data.lookCheck = false;
              data.createCheck = false;
              data.downloadCheck = false;
              data.editCheck = false;
              data.deleteCheck = false;
              _this2.lookCheck = false;
              _this2.createCheck = false;
              _this2.downloadCheck = false;
              _this2.editCheck = false;
              _this2.deleteCheck = false;
            }
            _this2.userList.push(data);
          });
        }
      });
    }
  }
};